<template>
  <StudioMultiSelect
    v-model="selected"
    :searchable="searchable"
    :items="selectItems"
    :label="label"
    :placeholder="placeholder"
    :clearable="clearable"
  >
    <template v-slot:selection="{item, index}">
      <v-chip
        v-if="index < minimumFilterView"
        small
      >
        <span>{{ getText(item) }}</span>
      </v-chip>
      <span
        v-if="index === minimumFilterView"
        class="grey--text caption"
      >
        (+{{ selected.length - minimumFilterView }} {{ message }})
      </span>
    </template>
  </StudioMultiSelect>
</template>

<script>
import StudioMultiSelect from '@/components/filter/models/StudioMultiSelect';

export default {
  name: 'MultiSelectFilter',
  components: {
    StudioMultiSelect,
  },
  props: {
    value: {
      type: Object,
      default: () => {},
    },
    selectItems: {
      type: Array,
      default: () => [],
    },
    label: {
      type: String,
      default: '',
    },
    searchable: {
      type: Boolean,
      default: true,
    },
    clearable: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      minimumFilterView: 1,
    };
  },
  computed: {
    placeholder() {
      return this.$t('components.filters.MultiSelectFilter.placeholder');
    },
    selected: {
      get() {
        if (this.value && this.value.value) {
          return this.value.value;
        }

        return [];
      },
      set(newValue) {
        let newValueProcessed = newValue;

        if (!newValue || newValue.length === 0) {
          return this.$emit('input', undefined);
        }

        if (newValue && newValue.length && typeof (newValue[0]) === 'object') {
          newValueProcessed = newValue.map(v => v && v.value);
        }

        this.$emit('input', {
          value: newValueProcessed,
        });
      },
    },
    message() {
      return this.selected.length - this.minimumFilterView === 1 ? 'outro' : 'outros';
    },
  },
  methods: {
    getText(item) {
      return typeof item === 'object' ? item.text : item;
    },
  },
};

</script>

<style scoped lang="scss">
  .v-select__selection.v-select__selection--comma {
    line-height: 120%;
  }
</style>
